import { Creature } from "src/classes/Creature";
import { DropItem } from "src/classes/DropItem";
import { FueFollet } from "src/classes/FueFollet";
import { KeyItem } from "src/classes/Keys";
import { LandmarkManager } from "src/classes/Landmarks";
import { Landscape } from "src/classes/Landscape";
import { Player } from "src/classes/Player";
import { Bullet } from "src/classes/SlingShot";
import { StoryItem } from "src/classes/StoryItem";
import { Structure } from "src/classes/Structure";
import UIScene from "src/classes/UI/UIScene";
import { bounceGameObject } from "src/classes/Utilities";
import MainScene from "./MainScene";
import { syncGameStateWithServer } from "../utils/game-state-manager";

export default class BootScene extends Phaser.Scene {
  
  logo: Phaser.GameObjects.Image;
  loadProgress: number;
  progressBar: Phaser.GameObjects.Graphics;
  loadingText: Phaser.GameObjects.Text;
  progressBox: Phaser.GameObjects.Graphics;

  constructor() {
    super({ key: 'BootScene' });
  }

  preload() {
    this.load.image('logo', 'assets/logos/SmallTownLogoCleaned.png'); 
  }

  
  create() {
    this.loadProgress = 0;

    // Create progress bar
    this.progressBar = this.add.graphics();

    // Center screen coordinates
    const { width, height } = this.scale;

    // Display logo
    this.logo = this.add.image(width/2, height/2, 'logo').setScale(0.5);

    // Create progress bar background
    this.progressBox = this.add.graphics();
    this.progressBox.fillStyle(0x222222, 0.8);
    this.progressBox.fillRect(width / 2 - 160, height / 2 + 100, 320, 50);

    // Text above the bar
    this.loadingText = this.add.text(width / 2, height / 2 + 80, 'Loading...', {
      fontSize: '20px',
    }).setOrigin(0.5, 0.5);

    bounceGameObject(this.logo, true);
    
    // Set up loader events
    this.load.on('progress', (value) => {
      this.loadProgress = value;
    });

    this.load.on('complete', async () => {
      // Start main scene when loading is complete
      
      // Retrieve tokens from local storage
      await MainScene.getTokens();
      MainScene.hotFix();// Fix any token issues from previous versions.
  
      await syncGameStateWithServer();
      await MainScene.getTokens();

      this.scene.start('mainScene');
    });
    
    // Start loading assets
    this.loadAssets();
  }

  update() {
    const { width, height } = this.scale;

    // Redraw the progress bar
    if(this.logo){
      this.logo.setPosition(width / 2, height / 2);
      this.loadingText.setPosition(width / 2, (height + this.logo.height) / 2);
      this.progressBox.setPosition(width / 2, (height + this.logo.height /2));
      this.progressBar.clear();
      this.progressBar.fillStyle(0xffffff, 1);
      this.progressBar.fillRect(width / 2, (height + this.logo.height /2), 300 * this.loadProgress, 30);
    }
  }

  loadAssets(){
    // Load landscapes atlas
    Landscape.preload(this);

    //  Load the player assets
    Player.preload(this);

    // Load fue follet particle resources
    FueFollet.preload(this);

    // Load all creature assets
    Creature.preload(this);

    // Load all drop item assets
    DropItem.preload(this);

    // Load all story item assets
    StoryItem.preload(this);

    // Load all key assets
    KeyItem.preload(this);

    // Load all landmarks
    LandmarkManager.preload(this);

    // Load structure assets.
    Structure.preload(this);

    // Load audio for slingshot
    Bullet.preload(this);

    // Load icons needed for UI scene
    UIScene.preload(this);

    // Start the loader manually
    this.load.start();
  }

}